import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 逐仓杠杆交易
enum API {
  // 逐仓杠杆总资产、负债、账户权益
  MarginIsolatedAccount = '/hk-web/margin/isolated/account',
  // 逐仓币对资产、负债、账户权益
  MarginIsolatedAccountDetail = '/hk-web/margin/isolated/accountDetail',
  // 杠杆-逐仓借款
  MarginIsolatedBorrow = '/hk-web/margin/isolated/borrow',
  // 逐仓-借款记录
  MarginIsolatedBorrowRecord = '/hk-web/margin/isolated/borrowRecord',
  // 逐仓-利息记录
  MarginIsolatedInterestRecord = '/hk-web/margin/isolated/interestRecord',
  // 杠杆逐仓交易对档位信息
  MarginIsolatedLadder = '/hk-web/margin/isolated/ladder',
  // 逐仓-强平订单
  MarginIsolatedLiquidationDetail = '/hk-web/margin/isolated/liquidationDetail',
  // 逐仓-强平记录
  MarginIsolatedLiquidationRecord = '/hk-web/margin/isolated/liquidationRecord',
  // 杠杆逐仓交易对信息
  MarginIsolatedPair = '/hk-web/margin/isolated/pair',
  // 杠杆-逐仓还款
  MarginIsolatedRepay = '/hk-web/margin/isolated/repay',
  // 逐仓-还款记录
  MarginIsolatedRepayRecord = '/hk-web/margin/isolated/repayRecord',
  // 逐仓交易对
  MarginIsolatedTradeTypes = '/hk-web/margin/isolated/tradeTypes',
  // 逐仓-划转记录
  MarginIsolatedTransferRecord = '/hk-web/margin/isolated/transferRecord',
  // 逐仓借款--前置查询
  MarginIsolatedUserBorrowInfo = '/hk-web/margin/isolated/userBorrowInfo',
  // 逐仓还款--前置查询
  MarginIsolatedUserRepayInfo = '/hk-web/margin/isolated/userRepayInfo',
  // 杠杆-平仓
  MarginIsolatedClosePosition = '/hk-web/margin/isolated/closePosition',
  // 查询杠杆逐仓资产最大可借
  MarginIsolatedMaxBorrowable = '/hk-web/margin/isolated/maxBorrowable',
  // 根据交易对查询杠杆用户资产
  MarginIsolatedPairAssets = '/hk-web/margin/isolated/pairAssets',
  // 逐仓杠杆总资产、负债、账户权益，与资产推送保持一致
  MarginIsolatedAsset = '/hk-web/margin/isolated/asset',
}

export type TGetMarginIsolatedAccountParams = any
export type TGetMarginIsolatedAccountResponse = TResponse<{
  allIsolatedAssetsInBtc?: string // 总资产折合成BTC
  allIsolatedAssetsInCny?: string // 总资产折合成人民币
  allIsolatedAssetsInEth?: string // 总资产折合成ETH
  allIsolatedAssetsInUsdt?: string // 总资产折合成USDT
  allIsolatedDebtInBtc?: string // 总负债折合成BTC
  allIsolatedDebtInCny?: string // 总负债折合成人民币
  allIsolatedDebtInEth?: string // 总负债折合成ETH
  allIsolatedDebtInUsdt?: string // 总负债折合成USDT
  allIsolatedNetAssetsInBtc?: string // 净资产折合成BTC
  allIsolatedNetAssetsInCny?: string // 净资产折合成人民币
  allIsolatedNetAssetsInEth?: string // 净资产折合成ETH
  allIsolatedNetAssetsInUsdt?: string // 净资产折合成USDT
  assetDetails?: {
    base?: {
      borrowed?: string // 当前借币数量
      coinId?: number // 币种id
      coinName?: string // 币种名称
      createdBy?: string
      createdTime?: string
      free?: string // 可用数量
      frozen?: string // 冻结数量
      imageUrl?: string // 币种Logo
      interest?: string // 当前未归还利息数量
      magIsolatedAssets?: string // 资产
      magIsolatedAssetsInCny?: string // 资产折合成人民币
      magIsolatedAssetsInUsdt?: string // 资产折合成USDT
      magIsolatedDebt?: string // 负债
      magIsolatedDebtInCny?: string // 负债折合成人民币
      magIsolatedDebtInUsdt?: string // 负债折合成USDT
      magIsolatedNetAssets?: string // 净资产
      magIsolatedNetAssetsInCny?: string // 净资产折合成人民币
      magIsolatedNetAssetsInUsdt?: string // 净资产折合成USDT
      sortId?: number // 币种序号
      tradeId?: number // 逐仓交易对id
      updatedBy?: string
      updatedTime?: string
      userId?: number // 用户id
    }
    isDebt?: string // 是否负债 0-否，1-是
    marginLevel?: string // 用户杠杆风险率
    marginLevelRisk?: number // 风险等级：1低风险、2中风险、3高风险
    marginRatio?: string // 逐仓有效杠杆倍数
    quote?: {
      borrowed?: string // 当前借币数量
      coinId?: number // 币种id
      coinName?: string // 币种名称
      createdBy?: string
      createdTime?: string
      free?: string // 可用数量
      frozen?: string // 冻结数量
      imageUrl?: string // 币种Logo
      interest?: string // 当前未归还利息数量
      magIsolatedAssets?: string // 资产
      magIsolatedAssetsInCny?: string // 资产折合成人民币
      magIsolatedAssetsInUsdt?: string // 资产折合成USDT
      magIsolatedDebt?: string // 负债
      magIsolatedDebtInCny?: string // 负债折合成人民币
      magIsolatedDebtInUsdt?: string // 负债折合成USDT
      magIsolatedNetAssets?: string // 净资产
      magIsolatedNetAssetsInCny?: string // 净资产折合成人民币
      magIsolatedNetAssetsInUsdt?: string // 净资产折合成USDT
      sortId?: number // 币种序号
      tradeId?: number // 逐仓交易对id
      updatedBy?: string
      updatedTime?: string
      userId?: number // 用户id
    }
    tradeId?: number // 逐仓交易对id
  }[] // 逐仓币对资产详情列表
  smallAssetsHideThreshold?: string // 隐藏小余额资产
}>
export const getMarginIsolatedAccount = (params?: TGetMarginIsolatedAccountParams) => {
  return hcAxios.get<TGetMarginIsolatedAccountResponse>(API.MarginIsolatedAccount, { params })
}

export type TGetMarginIsolatedAccountDetailParams = {
  tradeId?: any // tradeId
}
export type TGetMarginIsolatedAccountDetailResponse = TResponse<{
  base?: {
    borrowed?: string // 当前借币数量
    coinId?: number // 币种id
    coinName?: string // 币种名称
    createdBy?: string
    createdTime?: string
    free?: string // 可用数量
    frozen?: string // 冻结数量
    imageUrl?: string // 币种Logo
    interest?: string // 当前未归还利息数量
    magIsolatedAssets?: string // 资产
    magIsolatedAssetsInCny?: string // 资产折合成人民币
    magIsolatedAssetsInUsdt?: string // 资产折合成USDT
    magIsolatedDebt?: string // 负债
    magIsolatedDebtInCny?: string // 负债折合成人民币
    magIsolatedDebtInUsdt?: string // 负债折合成USDT
    magIsolatedNetAssets?: string // 净资产
    magIsolatedNetAssetsInCny?: string // 净资产折合成人民币
    magIsolatedNetAssetsInUsdt?: string // 净资产折合成USDT
    sortId?: number // 币种序号
    tradeId?: number // 逐仓交易对id
    updatedBy?: string
    updatedTime?: string
    userId?: number // 用户id
  }
  isDebt?: string // 是否负债 0-否，1-是
  marginLevel?: string // 用户杠杆风险率
  marginLevelRisk?: number // 风险等级：1低风险、2中风险、3高风险
  marginRatio?: string // 逐仓有效杠杆倍数
  quote?: {
    borrowed?: string // 当前借币数量
    coinId?: number // 币种id
    coinName?: string // 币种名称
    createdBy?: string
    createdTime?: string
    free?: string // 可用数量
    frozen?: string // 冻结数量
    imageUrl?: string // 币种Logo
    interest?: string // 当前未归还利息数量
    magIsolatedAssets?: string // 资产
    magIsolatedAssetsInCny?: string // 资产折合成人民币
    magIsolatedAssetsInUsdt?: string // 资产折合成USDT
    magIsolatedDebt?: string // 负债
    magIsolatedDebtInCny?: string // 负债折合成人民币
    magIsolatedDebtInUsdt?: string // 负债折合成USDT
    magIsolatedNetAssets?: string // 净资产
    magIsolatedNetAssetsInCny?: string // 净资产折合成人民币
    magIsolatedNetAssetsInUsdt?: string // 净资产折合成USDT
    sortId?: number // 币种序号
    tradeId?: number // 逐仓交易对id
    updatedBy?: string
    updatedTime?: string
    userId?: number // 用户id
  }
  tradeId?: number // 逐仓交易对id
}>
export const getMarginIsolatedAccountDetail = (params?: TGetMarginIsolatedAccountDetailParams) => {
  return hcAxios.get<TGetMarginIsolatedAccountDetailResponse>(API.MarginIsolatedAccountDetail, { params })
}

export type TPostMarginIsolatedBorrowParams = {
  borrowAmount?: string // 借款数量
  borrowType?: string
  coinId?: number // 币种id
  tradeId?: number // 逐仓交易对id
  userId?: number
}
export type TPostMarginIsolatedBorrowResponse = TResponse<number>
export const postMarginIsolatedBorrow = (params?: TPostMarginIsolatedBorrowParams) => {
  return hcAxios.post<TPostMarginIsolatedBorrowResponse>(API.MarginIsolatedBorrow, params)
}

export type TGetMarginIsolatedBorrowRecordParams = {
  coinId?: any // 币种id
  count?: any // 是否返回总记录数，默认true
  endDate?: any // 结束时间
  endDateTime?: any
  marginMode?: any
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  startDate?: any // 开始时间
  startDateTime?: any
  tradeId?: any // 交易对id
  userId?: any
}
export type TGetMarginIsolatedBorrowRecordResponse = TResponse<
  {
    amount?: string // 数量
    borrowType?: number // 借款类型，0手动借款，1自动借款
    coinId?: number // 币种id
    coinName?: string // 币种名称
    createdTime?: string // 时间
    id?: number // 借款id
    tradeId?: number // 逐仓交易对id，当全仓时为0
  }[]
>
export const getMarginIsolatedBorrowRecord = (params?: TGetMarginIsolatedBorrowRecordParams) => {
  return hcAxios.get<TGetMarginIsolatedBorrowRecordResponse>(API.MarginIsolatedBorrowRecord, { params })
}

export type TGetMarginIsolatedInterestRecordParams = {
  coinId?: any // 币种id
  count?: any // 是否返回总记录数，默认true
  endDate?: any // 结束时间
  endDateTime?: any
  marginMode?: any
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  startDate?: any // 开始时间
  startDateTime?: any
  tradeId?: any // 交易对id
  userId?: any
}
export type TGetMarginIsolatedInterestRecordResponse = TResponse<
  {
    coinId?: number // 币种id
    coinName?: string // 币种Name
    createdTime?: string // 时间
    dailyInterestRate?: string // 日利率
    id?: number // id
    interest?: string // 利息
    interestType?: number // 利息类型，1借款利息，2定时计息
    principal?: string // 本金
    tradeId?: number // 交易对id
  }[]
>
export const getMarginIsolatedInterestRecord = (params?: TGetMarginIsolatedInterestRecordParams) => {
  return hcAxios.get<TGetMarginIsolatedInterestRecordResponse>(API.MarginIsolatedInterestRecord, { params })
}

export type TGetMarginIsolatedLadderParams = {
  tradeId?: any // 交易对id
}
export type TGetMarginIsolatedLadderResponse = TResponse<
  {
    baseMaxBorrow?: string // 标的币最大可借
    createdBy?: string // 创建人
    createdTime?: string // 创建时间
    id?: number // id
    initialRatio?: string // 初始风险率
    ladder?: number // 档位编号
    liquidationRatio?: string // 强平风险率
    marginCallRatio?: string // 补充保证金风险率，规则：强平风险率+0.04
    marginRatio?: string // 有效倍数
    maxMarginRatio?: number // 逐仓最大杠杆倍数，3/5/10
    quoteMaxBorrow?: string // 计价币最大可借
    tradeId?: number // 交易对id
    updatedBy?: string // 更新人
    updatedTime?: string // 更新时间
  }[]
>
export const getMarginIsolatedLadder = (params?: TGetMarginIsolatedLadderParams) => {
  return hcAxios.get<TGetMarginIsolatedLadderResponse>(API.MarginIsolatedLadder, { params })
}

export type TGetMarginIsolatedLiquidationDetailParams = {
  txId?: any // txId
}
export type TGetMarginIsolatedLiquidationDetailResponse = TResponse<any[]>
export const getMarginIsolatedLiquidationDetail = (params?: TGetMarginIsolatedLiquidationDetailParams) => {
  return hcAxios.get<TGetMarginIsolatedLiquidationDetailResponse>(API.MarginIsolatedLiquidationDetail, { params })
}

export type TGetMarginIsolatedLiquidationRecordParams = {
  coinId?: any // 币种id
  count?: any // 是否返回总记录数，默认true
  endDate?: any // 结束时间
  endDateTime?: any
  marginMode?: any
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  startDate?: any // 开始时间
  startDateTime?: any
  tradeId?: any // 交易对id
  userId?: any
}
export type TGetMarginIsolatedLiquidationRecordResponse = TResponse<
  {
    endTime?: string // 强平结束时间
    id?: number // id
    liquidationAssetValue?: string // 平仓时总资产估值(USDT)
    liquidationClearanceFee?: string // 强平清算费用估值(USDT)
    liquidationDebtValue?: string // 平仓时总负债估值(USDT)
    liquidationRatio?: string // 平仓时风险率
    startTime?: string // 强平开始时间
    tradeId?: number // 逐仓交易对id
  }[]
>
export const getMarginIsolatedLiquidationRecord = (params?: TGetMarginIsolatedLiquidationRecordParams) => {
  return hcAxios.get<TGetMarginIsolatedLiquidationRecordResponse>(API.MarginIsolatedLiquidationRecord, { params })
}

export type TGetMarginIsolatedPairParams = any
export type TGetMarginIsolatedPairResponse = TResponse<
  {
    base?: string // 标的币Name
    baseBorrowable?: boolean // 标的币能否借币，默认0不可借 1可借
    baseCoinId?: number // 标的币id
    baseDailyInterestRate?: string // 标的币日利率
    baseMaxBorrow?: string // 标的币最大可借
    baseTransferinable?: boolean // 标的币能否转入，默认0不可转入 1可转入
    baseTransferoutable?: boolean // 标的币能否转出，默认0不可转出 1可转出
    baseYearInterestRate?: string // 标的币年利率
    id?: number
    marginTradeable?: boolean // 交易状态，默认0不可交易 1可交易
    maxMarginRatio?: number // 逐仓最大杠杆倍数
    quote?: string // 计价币Name
    quoteBorrowable?: boolean // 计价币能否借币，默认0不可借 1可借
    quoteCoinId?: number // 计价币id
    quoteDailyInterestRate?: string // 计价币日利率
    quoteMaxBorrow?: string // 计价币最大可借
    quoteTransferinable?: boolean // 计价币能否转入，默认0不可转入 1可转入
    quoteTransferoutable?: boolean // 计价币能否转出，默认0不可转出 1可转出
    quoteYearInterestRate?: string // 计价币年利率
    tradeArea?: string // 交易区，比如BTC、USDT
    tradeId?: number // 交易对id
  }[]
>
export const getMarginIsolatedPair = (params?: TGetMarginIsolatedPairParams) => {
  return hcAxios.get<TGetMarginIsolatedPairResponse>(API.MarginIsolatedPair, { params })
}

export type TPostMarginIsolatedRepayParams = {
  coinId?: number // 币种id
  repayAmount?: string // 还款数量
  tradeId?: number // 逐仓币对id
  userId?: number
}
export type TPostMarginIsolatedRepayResponse = TResponse<number>
export const postMarginIsolatedRepay = (params?: TPostMarginIsolatedRepayParams) => {
  return hcAxios.post<TPostMarginIsolatedRepayResponse>(API.MarginIsolatedRepay, params)
}

export type TGetMarginIsolatedRepayRecordParams = {
  coinId?: any // 币种id
  count?: any // 是否返回总记录数，默认true
  endDate?: any // 结束时间
  endDateTime?: any
  marginMode?: any
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  startDate?: any // 开始时间
  startDateTime?: any
  tradeId?: any // 交易对id
  userId?: any
}
export type TGetMarginIsolatedRepayRecordResponse = TResponse<
  {
    amount?: string // 总额
    coinId?: number // 币种id
    coinName?: string // 币种名称
    createdTime?: string // 时间
    id?: number // 还款id
    interest?: string // 利息
    principal?: string // 本金
    repayType?: number // 还款类型，0手动还款，1自动还款，2强平还款
    symbol?: number // 交易对名称
    tradeId?: number // 交易对id
    transNo?: number // 交易流水号
  }[]
>
export const getMarginIsolatedRepayRecord = (params?: TGetMarginIsolatedRepayRecordParams) => {
  return hcAxios.get<TGetMarginIsolatedRepayRecordResponse>(API.MarginIsolatedRepayRecord, { params })
}

export type TGetMarginIsolatedTradeTypesParams = any
export type TGetMarginIsolatedTradeTypesResponse = TResponse<
  {
    base?: string // 标的币名称
    baseBorrowable?: boolean // 标的币能否借币，默认0不可借 1可借
    baseCoinId?: number // 标的币id
    baseImageUrl?: string // 标的币Logo
    baseSortId?: number // 标的币序号
    baseTransferinable?: boolean // 标的币能否转入，默认0不可转入 1可转入
    baseTransferoutable?: boolean // 标的币能否转出，默认0不可转出 1可转出
    digit?: string // 有效小数位控制
    id?: number
    marginTradeAble?: boolean // 能否杠杆交易，默认flase 不可交易 true可交易
    quote?: string // 计价币名称
    quoteBorrowable?: boolean // 计价币能否借币，默认0不可借 1可借
    quoteCoinId?: number // 计价币id
    quoteImageUrl?: string // 计价币Logo
    quoteSortId?: number // 计价币序号
    quoteTransferinable?: boolean // 计价币能否转入，默认0不可转入 1可转入
    quoteTransferoutable?: boolean // 计价币能否转出，默认0不可转出 1可转出
    tradeId?: number // 交易对id
  }[]
>
export const getMarginIsolatedTradeTypes = (params?: TGetMarginIsolatedTradeTypesParams) => {
  return hcAxios.get<TGetMarginIsolatedTradeTypesResponse>(API.MarginIsolatedTradeTypes, { params })
}

export type TGetMarginIsolatedTransferRecordParams = {
  coinId?: any // 币种id
  count?: any // 是否返回总记录数，默认true
  endDate?: any // 结束时间
  endDateTime?: any
  marginMode?: any
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
  startDate?: any // 开始时间
  startDateTime?: any
  tradeId?: any // 交易对id
  userId?: any
}
export type TGetMarginIsolatedTransferRecordResponse = TResponse<
  {
    amount?: string // 划转数量
    coinId?: number // 币种id
    coinName?: string // 币种名称
    createdTime?: string // 时间
    id?: number // id
    remark?: string // 审核备注
    sourceWallet?: number // 来源账户 2-现货钱包 3-C2C钱包 5-合约钱包 6-全仓杠杆钱包 7-逐仓杠杆钱包
    status?: number // 状态 1已完成 2审核中 3驳回
    targetWallet?: number // 目标账户 2-现货钱包 3-C2C钱包 5-合约钱包 6-全仓杠杆钱包 7-逐仓杠杆钱包
    tradeId?: number // 交易对id
    transNo?: number // 交易流水号
    transferType?: number // 划转类型，1币币账户到杠杆账户，2杠杆账户到币币账户
  }[]
>
export const getMarginIsolatedTransferRecord = (params?: TGetMarginIsolatedTransferRecordParams) => {
  return hcAxios.get<TGetMarginIsolatedTransferRecordResponse>(API.MarginIsolatedTransferRecord, { params })
}

export type TGetMarginIsolatedUserBorrowInfoParams = {
  coinId?: any // coinId
  tradeId?: any // tradeId
}
export type TGetMarginIsolatedUserBorrowInfoResponse = TResponse<{
  available?: string // 可用余额
  borrowed?: string // 当前已借
  coinId?: number // 币种id
  coinName?: string // 币种名称
  hourInterestRate?: string // 小时利率
  ladder?: number // 逐仓档位，仅逐仓时有效
  maxBorrowable?: string // 最大可借数量
  precision?: number // 币种精度
  symbol?: string // 币对名称
  tradeId?: number // 币对id
}>
export const getMarginIsolatedUserBorrowInfo = (params?: TGetMarginIsolatedUserBorrowInfoParams) => {
  return hcAxios.get<TGetMarginIsolatedUserBorrowInfoResponse>(API.MarginIsolatedUserBorrowInfo, { params })
}

export type TGetMarginIsolatedUserRepayInfoParams = {
  coinId?: any // coinId
  tradeId?: any // tradeId
}
export type TGetMarginIsolatedUserRepayInfoResponse = TResponse<{
  available?: string // 可用余额
  borrowed?: string // 已借
  coinId?: number // 币种id
  coinName?: string // 币种名称
  interest?: string // 利息
  maxReturnable?: string // 最大可还数量
  precision?: number // 币种精度
  totalDebt?: string // 总负债
  tradeId?: number // 币对id
  userId?: number // 用户id
}>
export const getMarginIsolatedUserRepayInfo = (params?: TGetMarginIsolatedUserRepayInfoParams) => {
  return hcAxios.get<TGetMarginIsolatedUserRepayInfoResponse>(API.MarginIsolatedUserRepayInfo, { params })
}

export type TPostMarginIsolatedClosePositionParams = {
  deviceInfo?: {
    buildCode?: string
    deviceId?: string
    deviceModel?: string
    ip?: string
    platform?: number
    requestClientEnum?: string
    sysVer?: string
    versionCode?: string
  }
  ip?: string // ip
  tradeId?: number // 逐仓币对id
  userId?: number
}
export type TPostMarginIsolatedClosePositionResponse = TResponse<any>
export const postMarginIsolatedClosePosition = (params?: TPostMarginIsolatedClosePositionParams) => {
  return hcAxios.post<TPostMarginIsolatedClosePositionResponse>(API.MarginIsolatedClosePosition, params)
}

export type TGetMarginIsolatedMaxBorrowableParams = {
  coinId?: any // coinId
  tradeId?: any // tradeId
}
export type TGetMarginIsolatedMaxBorrowableResponse = TResponse<string>
export const getMarginIsolatedMaxBorrowable = (params?: TGetMarginIsolatedMaxBorrowableParams) => {
  return hcAxios.get<TGetMarginIsolatedMaxBorrowableResponse>(API.MarginIsolatedMaxBorrowable, { params })
}

export type TGetMarginIsolatedPairAssetsParams = {
  tradeId?: any // tradeId
}
export type TGetMarginIsolatedPairAssetsResponse = TResponse<any>
export const getMarginIsolatedPairAssets = (params?: TGetMarginIsolatedPairAssetsParams) => {
  return hcAxios.get<TGetMarginIsolatedPairAssetsResponse>(API.MarginIsolatedPairAssets, { params })
}

export type TGetMarginIsolatedAssetParams = any
export type TGetMarginIsolatedAssetResponse = TResponse<{
  allAssetsInUsdt?: string // 总资产折合成USDT
  allDebtInUsdt?: string // 总负债折合成USDT
  allNetAssetsInUsdt?: string // 净资产折合成USDT
  list?: {
    base?: {
      borrowed?: string // 当前借币数量
      coinId?: number // 币种id
      free?: string // 可用数量
      frozen?: string // 冻结数量
      interest?: string // 当前未归还利息数量
      maxBorrowable?: string // 最大可借数量
      maxReturnable?: string // 最大可还数量
    } // 杠杆币种资产
    ladder?: number // 逐仓档位
    marginLevel?: string // 杠杆风险率
    marginLevelRisk?: number // 风险等级：1低风险、2中风险、3高风险
    quote?: {
      borrowed?: string // 当前借币数量
      coinId?: number // 币种id
      free?: string // 可用数量
      frozen?: string // 冻结数量
      interest?: string // 当前未归还利息数量
      maxBorrowable?: string // 最大可借数量
      maxReturnable?: string // 最大可还数量
    } // 杠杆币种资产
    tradeId?: number // 交易对id
  }[] // 逐仓杠杆钱包列表
  userId?: number
}>
export const getMarginIsolatedAsset = (params?: TGetMarginIsolatedAssetParams) => {
  return hcAxios.get<TGetMarginIsolatedAssetResponse>(API.MarginIsolatedAsset, { params })
}
